/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
var e = {
  redo: "r",
  undo: "z",
  center: "Alt",
  constraint: "Shift",
  snappingToggle: "Control",
  cancel: "Escape",
  delete: ["Backspace", "Delete"],
  complete: "Enter",
  vertexAdd: "f",
  pan: " "
};
export { e as SKETCH_KEYS };